import React from 'react'
import PropTypes from 'prop-types'

/**
  * @class Slider
  * @props {object} slide gives all details for a slide
  * Required - empty object by default
*/

class Slide extends React.Component {

  componentDidMount(): void {
    const slide = this.props.slide;
    if (slide.button_label) {
      this.refs.button.innerHTML = slide.button_label;
    }
  }

  render() {
    const slide = this.props.slide
    return (
      <div className="slide">
        {/* thumbnail could be empty*/}
        { slide.thumbnail &&
          <img src={ process.env.PUBLIC_URL + "/images/" + slide.thumbnail.split("/").pop() } alt={ slide.thumbnailLabel || "" } />
        }
        <div className="slide__content">
          <h3>{slide.baseline}</h3>
          {/* if route is empty, we don't show button */}
          { slide.route &&
            <a href={slide.route} className="button" ref="button">Découvrir</a>
          }
        </div>
      </div>
    )
  }
}

/**
  * Default Props
*/
Slide.defaultProps = {
  slide: {}
}

/**
  * Props Typing
*/
Slide.propTypes = {
  slide: PropTypes.object.isRequired
}

/*
  TODO
  See if we can adapt it to used it with Carousel (Agency container)
  See if we can define defaultProps for each element of slide object (like empty string for thumbnailLabel)
  or it defaultProps is not useless with isRequired
*/

export default Slide



// WEBPACK FOOTER //
// ./src/components/Slider/Slide.jsx